import { ApolloClient } from 'apollo-client'
import { InMemoryCache } from 'apollo-cache-inmemory'
import { setContext } from 'apollo-link-context'
import { createUploadLink } from 'apollo-upload-client'
import store from '@/store'

const authLink = setContext((_, { headers }) => {
  const token = store.state.authentication.authToken
  // return the headers to the context so httpLink can read them
  return {
    headers: {
      ...headers,
      authorization: token ? `JWT ${token}` : ''
    }
  }
})

const httpEndpoint = process.env.VUE_APP_GRAPHQL_URL
const uploadLink = createUploadLink({ uri: httpEndpoint })

export const apolloClient = new ApolloClient({
  cache: new InMemoryCache(),
  link: authLink.concat(uploadLink)
})
